import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig.jsx";

// Import global fetch interceptor (keep this)
import "./fetchInterceptor";

// Initialize MSAL instance for Azure Entra ID (External ID)
// MSAL v4 requires explicit initialize() before any operations (handleRedirectPromise, etc.)
const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));

// Initialize MSAL first, then render — ensures redirect processing starts immediately
msalInstance.initialize().then(() => {
  root.render(
    <React.StrictMode>
      <Suspense fallback="Loading...">
        <HelmetProvider>
          <BrowserRouter>
            <MsalProvider instance={msalInstance}>
              <App />
            </MsalProvider>
          </BrowserRouter>
        </HelmetProvider>
      </Suspense>
    </React.StrictMode>
  );
});

// Optional: performance monitoring
reportWebVitals();
